import sdk from "@/genuinevendor-sdk";

// initial state
const state = () => ({
  ads: [],
  sdkerror: ""
});

// getters
const getters = {};

// actions
const actions = {
  async getAllAds({ commit }) {
    try {
      commit("resetErrors");
      let ads = await sdk.getAds();
      commit("setAds", ads);
    } catch (e) {
      console.log(e);
      commit("errorOccured", e);
    }
  }
};

// mutations
const mutations = {
  resetErrors(state) {
    state.sdkerror = "";
  },
  errorOccured(state, e) {
    state.ads = [];
    typeof e === "object" ? (state.sdkerror = e.message) : (state.sdkerror = e);
  },
  setAds(state, ads) {
    state.ads = ads;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
